import { FC } from 'react';

const BrokenLinkMessage: FC = () => (
    <div>The link you followed is broken, no longer valid or inaccessible due to insufficient rights.</div>
)

export default BrokenLinkMessage;
